// @vendors
const React = require('react');
const PropTypes = require('prop-types');
// @constants
const { DATE_PICKER_CUSTOM_DATE_FORMAT, CLEAR_ALL_FILTERS_BUTTON_LABEL } = require('constants/commonsComponents');
// @commons
const { ClearAllFiltersButton } = require('commonsComponents/clearAllFiltersButton');
const { LabelFilterRange } = require('commonsComponents/labelFilterRange');
// @utils
const { getLanguage, formatText } = require('core/i18n').i18n;
// @helpers
const { countActiveFilters } = require('utilities/filtersHelper');

class AmazonCouponCodeContentFilter extends React.Component {

    buildDateFilterLabel() {
        const { immFilter, resetFilter } = this.props;
        const immFilterDate = immFilter.get('date');
        const language = getLanguage();
        const labelFromDate = immFilterDate.get('from').locale(language).format(formatText(DATE_PICKER_CUSTOM_DATE_FORMAT));
        const labelToDate = immFilterDate.get('to').locale(language).format(formatText(DATE_PICKER_CUSTOM_DATE_FORMAT));
        return (
            <LabelFilterRange
                key="filter-date"
                from={labelFromDate}
                to={labelToDate}
                closeCallback={() => resetFilter('date')}
            />
        );
    }

    createButtonClearAllFilters() {
        const { immFilter, clearFilters } = this.props;
        let response;
        if (countActiveFilters(immFilter) > 1) {
            response = (<ClearAllFiltersButton
                label={CLEAR_ALL_FILTERS_BUTTON_LABEL}
                onClick={clearFilters}
            />);
        }
        return response;
    }

    render() {
        const { immFilter } = this.props;
        const clearAllFiltersButton = this.createButtonClearAllFilters();
        let filterDateLabel;
        if (immFilter.getIn(['date','isActive'])) {
            filterDateLabel = this.buildDateFilterLabel();
        }
        return (
            <div>
                {filterDateLabel}
                {clearAllFiltersButton}
            </div>
        );
    }
}

AmazonCouponCodeContentFilter.propTypes = {
    clearFilters: PropTypes.func.isRequired,
    immFilter: PropTypes.object.isRequired,
    resetFilter: PropTypes.func.isRequired,
}
 
module.exports = AmazonCouponCodeContentFilter;
